import React, { useState } from "react";
import "./JobApplicationForm.scss";
import { useDispatch } from "react-redux";
import { sendJobApplicationEmail } from "../../actions/pages-actions";
import Spinner from "../Spinner/Spinner";

const JobApplicationForm = ({ data }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    try {
      const response = await dispatch(
        sendJobApplicationEmail(
          formData.fullName,
          formData.email,
          formData.message,
          data.id,
          data.nonce
        )
      );
      setMessage(response.message);
    } catch (err) {
      setMessage(err.message);
    }

    setFormData({
      fullName: "",
      email: "",
      message: "",
    });

    setSubmitted(false);

    setTimeout(() => setMessage(""), 4000);
  };

  return (
    <section className={"job-application-form"} id="apply">
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-8 offset-2"}>
            <h2>Interested? Apply now</h2>
            {message && <p className="submission-message">{message}</p>}
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
                placeholder="Full name"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Email address"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Introduce yourself..."
              />
              <button type="submit" className="btn" disabled={submitted}>
                {submitted ? <Spinner /> : "Submit Your Application"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobApplicationForm;
